const TYPES = {
    INIT_USER_INFO: 'INIT_USER_INFO'
};
export default TYPES;


// WEBPACK FOOTER //
// ./src/store/mutation_types.js